import { Controller, useForm } from 'react-hook-form'
import { BpInput } from '../../../../shared/components/forms/input/BpInput'
import { ForwardedRef, forwardRef, useEffect } from 'react'
import clsx from 'clsx'
import styles from './EditAffiliateForm.module.scss'

export interface IEditAffiliateFormData {
  name: string
  comment: string
  email: string
}

export interface IEditAffiliateFormParams {
  name?: string
  comment?: string
  email?: string
  onSubmit?: (data: IEditAffiliateFormData) => void
  onDirty?: (isDirty: boolean) => void
}

export const EditAffiliateForm = forwardRef(
  (
    { name, comment, email, onSubmit, onDirty }: IEditAffiliateFormParams,
    ref: ForwardedRef<HTMLFormElement>,
  ) => {
    const {
      control,
      handleSubmit,
      formState: { isDirty },
    } = useForm<IEditAffiliateFormData>({
      mode: 'onChange',
      defaultValues: {
        name,
        comment,
      },
    })

    useEffect(() => {
      if (onDirty) onDirty(isDirty)
    }, [isDirty])

    return (
      <form
        ref={ref}
        className={clsx(styles.form)}
        onSubmit={handleSubmit((data: IEditAffiliateFormData) => {
          if (onSubmit) onSubmit(data)
        })}
      >
        <Controller
          render={({ field }) => (
            <BpInput
              {...field}
              defaultValue={name}
              label='Affiliate ID'
              placeholder='Enter your name'
            />
          )}
          control={control}
          name='name'
        />
        <Controller
          render={({ field }) => (
            <BpInput
              {...field}
              defaultValue={comment}
              label='Comment'
              placeholder='Enter your comment'
            />
          )}
          control={control}
          name='comment'
        />
      </form>
    )
  },
)
